<mp-root-module-nav *mpHeaderElement="'left'" label="Plattformeinheiten" />

<mp-overview
  moduleTitle="Plattformeinheiten"
  [resultCount]="platformPackagingUnits().length"
  (searched)="getAll($event)"
>
  <button mat-menu-item routerLink="create">Neu</button>
  <cdk-virtual-scroll-viewport itemSize="60">
    <mp-overview-item *cdkVirtualFor="let item of platformPackagingUnits()" [path]="item.shortName">
      <h2>{{ item.longName }} ({{ item.shortName }})</h2>

      <button mat-menu-item (click)="deleteUnit(item.shortName)" [disabled]="!item.isDeletable">Löschen</button>
    </mp-overview-item>
  </cdk-virtual-scroll-viewport>
</mp-overview>
